import React from 'react';
import { getOrgTermsContent } from '../../content/utils.js';
import { PortfolioInfoLink, PortfolioProjectsLink } from '../links/index.jsx';
import Tabs from '../Tabs.jsx';

const PortfolioTabs = ({ portfolioId }) => (
  <Tabs>
    <Tabs.Tab label={getOrgTermsContent('portfolioInfo')}>
      <PortfolioInfoLink portfolioId={portfolioId} />
    </Tabs.Tab>
    <Tabs.Tab label={getOrgTermsContent('portfolioProjects')}>
      <PortfolioProjectsLink portfolioId={portfolioId} />
    </Tabs.Tab>
  </Tabs>
);

export default PortfolioTabs;
